import React from "react";
import { Touchable, View } from "../core";

export default class TouchableComponent extends React.Component {
    render() {
        const {
            hidden,
            disabled,
            style,
            children,
            onPress,
            tooltip,
        } = this.props;
        if (!!hidden) return null;
        else if (!!disabled) return <View tooltip={tooltip} style={style}>{children}</View>;
        else return <Touchable tooltip={tooltip} onPress={onPress} style={style}>{children}</Touchable>
    }
}